export const TODO_ADD = 'addTodo'
export const TODO_DELETE = 'deleteTodo'
export const TODO_EDITING = 'editingTodo'
export const TODO_EDIT = 'editTodo'